<template>
  <div class="content">
    <div class="history-client">
      <h3>진료 특이사항</h3>
      <div class="memo-info">
        <dl class="name-info">
          <dt>의사/병원</dt>
          <dd>{{ memo.dr_name }}</dd>

          <dt>상담구분</dt>
          <dd>{{ memo.consult_type_name }}</dd>

          <dt>작성일자</dt>
          <dd>{{ memo.created_at | date_format('YYYY-MM-DD (dd) HH:mm') }}</dd>

          <dt>내용</dt>
          <dd>{{ memo.content }}</dd>
        </dl>
      </div>   
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import moment from 'moment-timezone';
  import { nameByConstMixin } from '@/lib/mixins'

  export default {
    mixins: [nameByConstMixin],
    name: 'consult-memo-content',
    props: ['current_memo'],
    data () {
      return {
        memo: {},
      }
    },
    computed: {
        ...mapState(['account']),       
    },
    methods: {
      
    },
    async mounted () {
      // console.log('consultnotecontent 마운트됨!')
      //if(this.note_id) this.load_content(this.note_id)
      this.memo = current_memo;
    },
    watch: {
      current_memo: function (current_memo) {
        // console.log('current_memo 변경됨(watch)_content', current_memo)
        this.memo = current_memo;
      }
    },
  }
</script>

<style scoped>
  .content > div {
      margin-bottom: 30px;
  }
  .content h3 {
      color: #4c4c4c;
      margin-bottom: 20px;
      letter-spacing: -.5px;
      font: 500 18px 'Noto Sans KR', sans-serif;
  }
  .memo-info{
      margin-bottom:10px;
  }
  .memo-info-l{
      margin-bottom:10px;
  }
  .memo-info dt,
  .memo-info dd{
    font:400 12px Noto Sans KR,sans-serif;
    min-height:20px;
    margin-bottom:5px;
  }
  .memo-info-l dt,
  .memo-info-l dd{
    font:400 12px Noto Sans KR,sans-serif;
    min-height:20px;
    margin-bottom:5px;
  }
  .memo-info dt{
    float:left;
    width:70px;
    margin-right:10px;
    color:#b7b7b7;
  }
  .memo-info-m dt{
    float:left;
    width:150px;
    margin-right:10px;
    color:#b7b7b7;
  }
  .memo-info-l dt{
    float:left;
    width:300px;
    margin-right:10px;
    color:#b7b7b7;
  }
  .memo-info, .memo-info-m, .memo-info-l dd{
    overflow:hidden;
    color:#484848;
  }
  .memo-info .data-info{
    display:inline-block;
    width:50%;
    vertical-align:top;
  }
</style>
